import { tzAxios } from 'api/axios';
import { apiAlipayAuthcodeRequest } from 'api/requestTypes';
import { apiQiTokenResponse } from 'api/responseTypes';

export const apiAlipayAuthcode = async (payload: apiAlipayAuthcodeRequest) =>
  (await tzAxios.post<apiQiTokenResponse>(`/users/ticket-zone-mini-program-sign-up`, payload)).data;
